import { getToken } from "../Services/token";

const get_profile = () => {
  const host = window.location.host;
  if (host === "ielts-cms.web.app") return "production";
  if (host === "cms-ielts-cambri.web.app") return "staging";
  if (host === "localhost:3000" || host === "localhost:3001") return "dev";
  return "unknown";
};

let be_url = "https://prod.api.cms.ielts.cambri.ai";
let cloudUrl = "https://ictservice.cambri.ai/api/";

const profile = get_profile();
switch (profile) {
  case "dev":
    be_url = "https://prod.api.cms.ielts.cambri.ai";
    cloudUrl = "https://ictservice.cambri.ai/api/";
    break;

  case "staging":
    be_url = "https://prod.api.cms.ielts.cambri.ai";
    cloudUrl = "https://ictservice.cambri.ai/api/";
    break;

  case "production":
    be_url = "https://staging.api.cms.ielts.cambri.ai";
    cloudUrl = "https://ictsystems.cambri.ai/api/";
    break;

  default:
    console.warn(`Unknown profile: ${profile}`);
    break;
}

export const serviceUrl = be_url;

export const cloudServiceUrl = cloudUrl;

export const cloudApplicationUrl = get_profile() === "production" ? "ielts-cms.web.app" : "cms-ielts-cambri.web.app";

export const genericHeaders = () => {
  if (getToken("token") != null) {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken("token"),
    };
  }
  return {
    "Content-Type": "application/json",
  };
};
